export default __webpack_public_path__ + "static/media/arrow-left.6491eb62.svg";